import { useSearchParams } from "react-router-dom";

export const useReferral = () => {
  const [searchParams] = useSearchParams();
  const paramsReferral = searchParams.get("ref");
  const sessionReferral = localStorage.getItem("ref");

  if (paramsReferral && sessionReferral !== paramsReferral) {
    localStorage.setItem("ref", paramsReferral);
  }

  const referral = paramsReferral || sessionReferral;

  return { referral };
};
